import React, { createContext, useContext, useState, useCallback } from 'react';
import { login as apiLogin, clearToken } from '../services/authApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [loginError, setLoginError] = useState(null);
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (username, password) => {
    setLoading(true);
    setLoginError(null);
    try {
      const token = await apiLogin(username, password);
      setAuthToken(token);
      setIsLoggedIn(true);
      return true;
    } catch (err) {
      setLoginError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setAuthToken(null);
    setIsLoggedIn(false);
    setLoginError(null);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, authToken, login, logout, loginError, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
